// แปลง dd/MM/yyyy => yyMMdd
export function ConvertDatetoFormatTicket(date) {
  const parts = date.split("/");
  const day = parseInt(parts[0]);
  const month = parseInt(parts[1]) - 1; // JavaScript months are 0-based
  const year = parseInt(parts[2]);

  const dateObject = new Date(year, month, day);

  // Extract year, month, and day components
  const yy = dateObject.getFullYear().toString().slice(-2);
  const mm = (dateObject.getMonth() + 1).toString().padStart(2, "0");
  const dd = dateObject.getDate().toString().padStart(2, "0");

  // Format the components into yyMMdd format
  const convertedDate = `${yy}${mm}${dd}`;

  return convertedDate;
}

//แปลง  dd/MM/yyyy => date
export function ConvertFormatDatetoDate(date) {
  const inputDateParts = date.split("/");
  var dateNew = new Date(
    parseInt(inputDateParts[2], 10),
    parseInt(inputDateParts[1], 10) - 1,
    parseInt(inputDateParts[0], 10)
  );
  return dateNew;
}

//dateNow to ddMMyyyy_HHmm
export function ConvertDatetoFormatdateFileName() {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = String(now.getFullYear());
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  return `${day}${month}${year}_${hours}${minutes}`;
}

//date 2023-10-08T00:00:00 to dd/MM/yyyy
export function ConvertDatetoFormatdateNormal(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);

  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate;
}

// date to string
export const toDateString = (date, needTime) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  let dateString = day + "/" + month + "/" + year;

  if (needTime) {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    dateString += " " + hours + ":" + minutes + ":" + seconds;
  }

  return dateString;
};

//dateNow to 'dd/MM/yyyy HH24:mi:ss'
export function ConvertDateNowtoFormatDateTimeString() {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = String(now.getFullYear());
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

//datetime now to 'yyyy-MM-ddTHH24:MI:SS.xxxx'
export function ConvertDateNowToISOFormatDateTimeString() {
  const now = new Date();
  const year = String(now.getFullYear());
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const milliseconds = String(now.getMilliseconds()).padStart(3, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

//input to 'yyyy-MM-ddTHH24:MI:SS.xxxx'
export function ConvertInputDateToISOFormatDateTimeString(inputdate) {
  const inputDateObject = new Date(inputdate);
  const year = String(inputDateObject.getFullYear());
  const month = String(inputDateObject.getMonth() + 1).padStart(2, "0");
  const day = String(inputDateObject.getDate()).padStart(2, "0");
  const hours = String(inputDateObject.getHours()).padStart(2, "0");
  const minutes = String(inputDateObject.getMinutes()).padStart(2, "0");
  const seconds = String(inputDateObject.getSeconds()).padStart(2, "0");
  const milliseconds = String(inputDateObject.getMilliseconds()).padStart(3, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

//แปลง  '2023-11-10T00:00:00' => date
export function ConvertFormatDateTimetoDate(datetime) {
  const date = datetime?.split("T")[0];
  const time = datetime?.split("T")[1];

  const inputDateParts = date?.split("-");
  const inputTimeParts = time?.split(":");
  if(inputDateParts == null || inputDateParts.length == 0){ return null;}
  var dateNew = new Date();
  dateNew.setFullYear(inputDateParts[0]);
  dateNew.setMonth(inputDateParts[1]-1);
  dateNew.setDate(inputDateParts[2]);

  dateNew.setHours(inputTimeParts[0]);
  dateNew.setMinutes(inputTimeParts[1]);
  dateNew.setSeconds(inputTimeParts[2]);
  return dateNew;
}